import axios from '@axios'

async function getTranslations() {
  const { data } = await axios.get('translations/system-locales')

  return data.data.map(e => ({
    title: e.language,
    route: {
      name: 'translations',
      params: { lang: e.code },
      meta: {
        navActiveLink: e.code,
      },
      icon: 'GridIcon',
    },

  }))
}

export default async function settings() {
  return [
    {
      title: 'DEBTIA_SETTINGS',
      icon: 'GridIcon',
      action: 'settings',
      resource: 'settings',
      children: [
        {
          title: 'DEBTIA_TRANSLATIONS',
          route: 'translations',
          action: 'settings',
          resource: 'settings',
          children: await getTranslations(),
        },
        {
          title: 'DEBTIA_ROLE_MANAGEMENT',
          route: 'role-management',
          action: 'settings',
          resource: 'settings',
        },
      ],
    },
  ]
}
